var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "node-detail",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "div",
        { staticClass: "selector" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Node")) + ": ")
          ]),
          _c(
            "el-select",
            {
              attrs: { size: "small" },
              on: { change: _vm.onNodeChange },
              model: {
                value: _vm.nodeForm._id,
                callback: function($$v) {
                  _vm.$set(_vm.nodeForm, "_id", $$v)
                },
                expression: "nodeForm._id"
              }
            },
            _vm._l(_vm.nodeList, function(op) {
              return _c("el-option", {
                key: op._id,
                attrs: { value: op._id, label: op.name }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Overview"), name: "overview" } },
            [_c("node-overview")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Installation"), name: "installation" } },
            [_c("node-installation")],
            1
          ),
          false
            ? _c(
                "el-tab-pane",
                {
                  attrs: { label: _vm.$t("Deployed Spiders"), name: "spiders" }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Deployed Spiders")) + " ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }